import { atomWithLocalStorage } from "./comments/comments";

interface bulkRecordingPopupState {
    willShow: boolean;
}

export const INITIAL_BULK_RECORDING_POPUP_STATE: bulkRecordingPopupState = {
    willShow: true,
};

export const bulkRecordingPopupStateAtom = atomWithLocalStorage(
    "bulkRecordingPopupState",
    INITIAL_BULK_RECORDING_POPUP_STATE,
    []
);

export const setWillShowPopup = (setState, willshow) => {
    setState(state => {
        const newState = { ...state };

        newState.willShow = willshow;

        return newState;
    })
}
